import { ProdutoPrecoEditPopupComponent } from './produto-preco-edit-popup.component';
import { Parameters } from './../../../../../shared/interfaces/parameters';
import { ListaPreco } from 'app/shared/interfaces/lista-preco';
import { Preco } from 'app/shared/interfaces/preco';
import { CopiaPrecoItem } from 'app/shared/interfaces/copia-preco-item';
import { ProdutoService } from 'app/shared/services/produto.service';
import { Component, Inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { Produto } from 'app/shared/interfaces/produto';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';
import { LayoutService } from 'app/shared/services/layout.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { ListaPrecoTabela } from 'app/shared/interfaces/lista-preco-tabela';
import { ListaPrecoService } from 'app/shared/services/lista-preco.service';
import { ListaPrecoTabelaService } from 'app/shared/services/lista-preco-tabela.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { JwtAuthService } from 'app/shared/services/auth/jwt-auth.service';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { ParametroService } from 'app/shared/services/parametro.service';

/** Tabelas 1001..1005 são custo (real/NF/digitado/médio/inventário), não preço de venda. */
const TABELA_CUSTO_INICIO = 1001;
const TABELA_CUSTO_FIM = 1005;
/** Tabela base: alterá-la propaga o preço em cascata para as tabelas seguintes (fator/índice). */
const TABELA_BASE = 1;

@Component({
  selector: 'app-produto-preco-popup',
  templateUrl: './produto-preco-popup.component.html',
  styleUrls: ['./produto-preco-popup.component.scss']
})
export class ProdutoPrecoPopupComponent implements OnInit {

  produtoForm: FormGroup;
  produto: Produto;
  layoutConf: any;
  selectedListaPreco: ListaPreco;
  selectedTabelaPreco: ListaPrecoTabela;

  novoPreco = {} as Preco;
  precos: Preco[] = [];
  precos$: BehaviorSubject<Preco[]> = new BehaviorSubject<Preco[]>(null);
  listaPrecos: ListaPreco[] = [];
  tabelas$: BehaviorSubject<ListaPrecoTabela[]> = new BehaviorSubject<ListaPrecoTabela[]>(null);
  parameters: Parameters;

  /** Requisição em curso: trava os botões e mostra a barra de progresso. */
  salvando = false;
  /** Card em edição inline (chave lista/tabela) e valor digitado. */
  editandoChave: string = null;
  precoEmEdicao: number = null;
  /** Houve gravação: o produto-details só recarrega o produto se o diálogo devolver algo. */
  private alterou = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ProdutoPrecoPopupComponent>,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private confirmService: AppConfirmService,
    private layout: LayoutService,
    private produtoService: ProdutoService,
    private listaPrecoService: ListaPrecoService,
    private tabelaPrecoService: ListaPrecoTabelaService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private router: Router,
    private snack: MatSnackBar,
    private authService: JwtAuthService,
    private loader: AppLoaderService,
    private parametroService: ParametroService,

  ) { }


  ngOnInit(): void {
    this.layoutConf = this.layout.layoutConf;
    this.produto = this.data.payload;

    this.precos$.subscribe(precos => this.precos = this.ordenar(precos));
    this.precos$.next(this.produto.precos);

    // Listas restritas à filial DO PRODUTO: a listagem comum traz as listas de todo o
    // filialAccess e escolher a de outra filial grava o preço numa lista que não vale para a
    // filial do produto - é o que fazia aparecer card de outra filial ao voltar da edição.
    this.listaPrecoService.getListasPrecoDoProduto(this.produto.id, 1, 100).subscribe(
      (listas) => {
        this.listaPrecos = listas || [];
        this.selecionarListaPadrao();
      },
      (error) => {
        this.listaPrecos = [];
        this.confirmService.confirm(
          {
            message: `A T E N Ç Ã O !  ERRO CARREGANDO LISTAS DE PREÇO ... ${error}`,
            error: true
          });
      });
  }

  /**
   * Seleciona a lista padrão do fat_parameters da filial da sessão, mas sempre pela instância
   * que está em listaPrecos (o mat-select compara por referência). Quando o produto é de outra
   * filial acessível, a padrão da sessão não está na lista e cai na primeira da filial do produto.
   */
  private selecionarListaPadrao() {
    this.authService.getItem().subscribe((i) => {
      this.parametroService.getParametros(Number(i.filialId)).subscribe(
        (parametros) => {
          this.parameters = parametros;
          this.aplicarListaSelecionada(
            this.listaPrecos.find(lista => lista?.id === this.parameters?.fatListaPrecoPadrao));
        },
        (error) => {
          this.aplicarListaSelecionada(null);
          this.confirmService.confirm(
            {
              message: `A T E N Ç Ã O !  ERRO CARREGANDO PARAMETROS ... ${error}`,
              error: true
            });
        });
    });
  }

  private aplicarListaSelecionada(lista: ListaPreco) {
    this.selectedListaPreco = lista || this.listaPrecos[0];
    this.selectedTabelaPreco = null;
    this.buildProdutoForm(this.produto);
    this.changeLista();
  }

  buildProdutoForm(produto: Produto) {
    this.produtoForm = this.fb.group({
      lista: [this.selectedListaPreco],
      tabela: [this.selectedTabelaPreco],
      preco: [0],
    })

  }

  validateAllFormFields(formGroup: FormGroup) {         // {1}
    Object.keys(formGroup.controls).forEach(field => {  // {2}
      const control = formGroup.get(field);             // {3}
      if (control instanceof FormControl) {             // {4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        // {5}
        this.validateAllFormFields(control);            // {6}
      }
    });
  }


  /**
   * Troca de lista: as tabelas têm de vir da lista que está selecionada NO COMBO.
   * Antes usava sempre this.selectedListaPreco (nunca atualizado no selectionChange), então as
   * tabelas continuavam as da lista padrão e o preço acabava gravado noutro par lista/tabela.
   */
  changeLista() {
    const lista: ListaPreco = this.produtoForm?.controls['lista']?.value || this.selectedListaPreco;
    this.selectedListaPreco = lista;
    this.selectedTabelaPreco = null;
    this.produtoForm?.controls['tabela']?.setValue(null);
    this.tabelas$.next([]);
    if (!lista?.id) {
      return;
    }
    this.tabelaPrecoService.getListaPrecoTabela(lista.id).subscribe(tabelas => this.tabelas$.next(tabelas));
  }

  deletePreco(preco: Preco) {
    this.confirmService.confirm({ message: `Deseja realmente deletar o preço [${preco?.preco} - ${preco?.listaPreco?.descricao} - ${preco?.tabela?.descricao}]` })
      .subscribe(res => {
        if (res) {
          this.salvando = true;
          this.produtoService.deleteProdutoPreco(this.produto.id, preco.listaPreco.id, preco.tabela.id.tabelaId)
            .subscribe(precos => {
              this.salvando = false;
              this.alterou = true;
              this.aplicarPrecos(precos);
              this.aviso('Preço excluído.');
            }, () => {
              this.salvando = false;
              this.aviso('Não foi possível excluir o preço.', true);
            });
        }
      });
  }

  /**
   * Inclui o par lista/tabela escolhido já com o preço digitado na barra (antes entrava sempre
   * zerado e obrigava a abrir a edição em seguida).
   */
  incluirPreco(preco: Preco) {
    const lista = this.produtoForm.controls['lista'].value;
    const tabela = this.produtoForm.controls['tabela'].value;

    if (tabela === undefined || tabela === null || tabela === '') {
      this.aviso('Selecione uma Tabela de Preço e clique em Adicionar.', true);
      return;
    }

    // A tabela é a fonte da verdade do par lista/tabela: o id dela carrega a lista a que pertence
    // (id.fatListapre). Usar tabela.listaId/tabela.tabelaId (que não existem no JSON) deixava
    // listaId/tabelaId indefinidos e o backend caia num par lista/tabela diferente do escolhido.
    const listaId = tabela?.id?.fatListapre ?? lista?.id;
    const tabelaId = tabela?.id?.tabelaId;

    const tabelaFound = this.precos.find((reg) => reg.listaId === listaId && reg.tabelaId === tabelaId);
    if (tabelaFound !== undefined) {
      this.aviso('Essa Tabela de Preço já está na lista. Edite o card correspondente.', true);
      return;
    }

    preco = {} as Preco;
    preco.produtoId = this.produto.id;
    preco.listaId = listaId;
    preco.tabelaId = tabelaId;
    preco.listaPreco = this.listaPrecos?.find(l => l?.id === listaId) || lista;
    preco.tabela = tabela;
    preco.preco = Number(this.produtoForm.controls['preco'].value) || 0;

    // Envia só o preço novo: mandar this.precos inteiro regravava também as tabelas de custo
    // (1001..1005), cujo valor exibido vem do saldo e não do fat_produto_preco.
    this.salvando = true;
    this.produtoService.saveOrUpdatePrecos([preco]).subscribe(
      (precos) => {
        this.alterou = true;
        this.aplicarPrecos(precos);
        this.produtoForm.controls['preco'].setValue(0);
        this.produtoForm.controls['tabela'].setValue(null);
        this.selectedTabelaPreco = null;
        this.propagarSeTabelaBase(preco, () => this.aviso('Preço incluído.'));
      },
      () => {
        this.salvando = false;
        this.aviso('Não foi possível incluir o preço.', true);
      });

    return;
  }

  /** Edição inline: só o valor do preço, salvando com Enter ou ao sair do campo. */
  iniciarEdicaoInline(preco: Preco) {
    if (this.isCusto(preco)) {
      return;
    }
    this.editandoChave = this.chave(preco);
    this.precoEmEdicao = preco?.preco ?? 0;
  }

  cancelarEdicaoInline() {
    this.editandoChave = null;
    this.precoEmEdicao = null;
  }

  emEdicao(preco: Preco): boolean {
    return this.editandoChave === this.chave(preco);
  }

  salvarEdicaoInline(preco: Preco) {
    if (!this.emEdicao(preco)) {
      return;
    }
    const novoValor = Number(this.precoEmEdicao) || 0;
    this.cancelarEdicaoInline();
    if (novoValor === Number(preco?.preco || 0)) {
      return;
    }

    // Preserva promoção/observação do card: o backend grava o adapter inteiro.
    const payload: Preco = {
      ...preco,
      produtoId: this.produto.id,
      listaId: preco?.listaId ?? preco?.listaPreco?.id,
      tabelaId: preco?.tabelaId ?? preco?.tabela?.id?.tabelaId,
      preco: novoValor,
    };

    this.salvando = true;
    this.produtoService.saveOrUpdatePrecos([payload]).subscribe(
      (precos) => {
        this.alterou = true;
        this.aplicarPrecos(precos);
        this.propagarSeTabelaBase(payload, () => this.aviso('Preço atualizado.'));
      },
      () => {
        this.salvando = false;
        this.aviso('Não foi possível atualizar o preço.', true);
      });
  }

  /**
   * Tabela base alterada: propaga o preço às tabelas seguintes com fator/índice (mesma regra do
   * desktop), igual ao que o popup de edição já faz.
   */
  private propagarSeTabelaBase(preco: Preco, onFim: () => void) {
    const tabelaId = preco?.tabelaId ?? preco?.tabela?.id?.tabelaId;
    if (Number(tabelaId) !== TABELA_BASE) {
      this.salvando = false;
      onFim();
      return;
    }
    const item: CopiaPrecoItem = {
      produtoId: this.produto.id,
      precoBase: Number(preco?.preco) || 0,
      listaId: preco?.listaId ?? preco?.listaPreco?.id,
      tabelaId: tabelaId,
    };
    this.produtoService.copiaTabelaPreco([item]).subscribe(
      () => this.recarregarPrecos(() => {
        this.salvando = false;
        this.aviso('Preço gravado e propagado às tabelas seguintes (fator/índice).');
      }),
      () => {
        this.salvando = false;
        this.aviso('Preço gravado, mas não foi possível propagar às tabelas seguintes.', true);
      });
  }

  recarregarPrecos(onFim: () => void = () => { }) {
    this.produtoService.getPrecos(this.produto.id).subscribe(
      precos => {
        this.aplicarPrecos(precos);
        onFim();
      },
      () => onFim());
  }

  private aplicarPrecos(precos: Preco[]) {
    this.produto.precos = precos || [];
    this.precos$.next(this.produto.precos);
  }

  /** Ordena por lista e depois por tabela, deixando as tabelas de custo no fim. */
  private ordenar(precos: Preco[]): Preco[] {
    return [...(precos || [])].sort((a, b) => {
      const custoA = this.isCusto(a) ? 1 : 0;
      const custoB = this.isCusto(b) ? 1 : 0;
      if (custoA !== custoB) {
        return custoA - custoB;
      }
      const listaA = a?.listaId ?? a?.listaPreco?.id ?? 0;
      const listaB = b?.listaId ?? b?.listaPreco?.id ?? 0;
      if (listaA !== listaB) {
        return listaA - listaB;
      }
      return (a?.tabelaId ?? 0) - (b?.tabelaId ?? 0);
    });
  }

  private chave(preco: Preco): string {
    return `${preco?.listaId ?? preco?.listaPreco?.id}-${preco?.tabelaId ?? preco?.tabela?.id?.tabelaId}`;
  }

  /** Tabelas 1001..1005 espelham o custo do saldo: não se editam como preço. */
  isCusto(preco: Preco): boolean {
    const tabelaId = Number(preco?.tabelaId ?? preco?.tabela?.id?.tabelaId);
    return tabelaId >= TABELA_CUSTO_INICIO && tabelaId <= TABELA_CUSTO_FIM;
  }

  isTabelaBase(preco: Preco): boolean {
    return Number(preco?.tabelaId ?? preco?.tabela?.id?.tabelaId) === TABELA_BASE;
  }

  /** Promoção vigente (o backend só devolve percentualDesc/validade quando ainda vale). */
  temPromocao(preco: Preco): boolean {
    return !!preco?.validadePromocao && !!preco?.precoPromocao;
  }

  private aviso(mensagem: string, erro = false) {
    this.snack.open(mensagem, 'OK', { duration: erro ? 6000 : 3000 });
  }

  openProdutoPrecoPopUp(preco: any = {}) {
    let title = "PREÇO: ";
    let dialogRef: MatDialogRef<any> = this.dialog.open(ProdutoPrecoEditPopupComponent, {
      width: this.layout.isMobile ? '100vw' : '40%',
      maxWidth: '100vw',
      maxHeight: '100dvh',
      panelClass: this.layout.isMobile ? ['dialog-fullscreen'] : undefined,
      disableClose: true,
      data: { title: title + "[ " + this.produto.codigo + " - " + this.produto.descricao + " ] - [ " + preco.listaPreco.descricao + " Tab.:" + preco.tabela.codigo + " ]", payload: preco }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (res) {
          this.alterou = true;
        }
        this.recarregarPrecos();
      })
  }

  close() {
    this.dialogRef.close(this.alterou);
  }

}
